import { Box, Icon, Tooltip } from '@dixa/lib-shared-habla';

import { elevioApi } from 'components/conversation/components/integrations/elevio/src/utils/apis/graphql/api';
import { useAppSelector } from 'utils/redux/useAppSelector';

import { elevioSelectors } from '../../elevio.reducer/selectors';
import { buildArticleUrl } from '../../utils';

import styles from './OpenArticleInTab.module.scss';

type OpenArticleInTabProps = {
  /** Article slug - used to generate article URL's */
  articleSlug: string;
};
export function OpenArticleInTab({
  articleSlug,
}: OpenArticleInTabProps): JSX.Element {
  const { data } = elevioApi.datahub.useCompanySettingsQuery({});

  const languageId = useAppSelector(
    elevioSelectors.suggestion.selectedLanguageId,
  );

  const kbUrl = data?.settings.kbUrl || '';
  if (!kbUrl) return <></>;

  const articleUrl = buildArticleUrl({
    kbUrl,
    articleSlug,
    langCode: languageId,
  });

  const onClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>): void => {
    e.preventDefault();
    e.stopPropagation();
    window.open(articleUrl, '_blank', 'noopener noreferrer');
  };

  return (
    <Tooltip content="Open Article" dark placement="top">
      <Box height="16px" className={styles.openArticleInTab} onClick={onClick}>
        <Icon name="external-link" />
      </Box>
    </Tooltip>
  );
}
